import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profile: null,
  loading: false,
  isVerified: false,
  // Mentor profile data
  firstName: null,
  lastName: null,
  profileImage: null,
  // New fields for mentors caching
  mentors: [],
  mentorsLoading: false,
  mentorsError: null,
  lastFetched: null,
  mentorsCacheExpiry: 24 * 60 * 60 * 1000, // 1 day in milliseconds
};

const mentorProfile = createSlice({
  name: "mentor",
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.profile = action.payload;
      state.loading = false;
      // Extract mentor profile data
      if (action.payload) {
        state.firstName = action.payload.firstName || null;
        state.lastName = action.payload.lastName || null;
        state.profileImage = action.payload.profileImage || action.payload.profileImage || null;
      }
    },
    setUser: (state, action) => {
      state.isVerified = action.payload.isVerified;
      state.loading = false;
    },
    setLoading: (state) => {
      state.loading = true;
    },
    clearUser: (state) => {
      state.isVerified = null;
      state.loading = false;
      // Clear mentor profile data
      state.firstName = null;
      state.lastName = null;
      state.profileImage = null;
    },
    // New reducers for mentors
    setMentors: (state, action) => {
      state.mentors = action.payload;
      state.mentorsLoading = false;
      state.mentorsError = null;
      state.lastFetched = Date.now();
    },
    setMentorsLoading: (state, action) => {
      state.mentorsLoading = action.payload;
    },
    setMentorsError: (state, action) => {
      state.mentorsError = action.payload;
      state.mentorsLoading = false;
    },
    clearMentors: (state) => {
      state.mentors = [];
      state.lastFetched = null;
      state.mentorsError = null;
    },
  },
});

export const { 
  setProfile, 
  setUser, 
  clearUser, 
  setLoading,
  setMentors,
  setMentorsLoading,
  setMentorsError,
  clearMentors
} = mentorProfile.actions;

// Selectors
export const selectMentors = (state) => state.mentor.mentors;
export const selectMentorsLoading = (state) => state.mentor.mentorsLoading;
export const selectMentorsError = (state) => state.mentor.mentorsError;
export const selectMentorsCacheValid = (state) => {
  const { lastFetched, mentorsCacheExpiry } = state.mentor;
  return lastFetched && (Date.now() - lastFetched) < mentorsCacheExpiry;
};

// Mentor profile selectors
export const selectMentorProfile = (state) => state.mentor.profile;
export const selectMentorFirstName = (state) => state.mentor.firstName;
export const selectMentorLastName = (state) => state.mentor.lastName;
export const selectMentorprofileImage = (state) => state.mentor.profileImage;
export const selectMentorLoading = (state) => state.mentor.loading;

export default mentorProfile.reducer;
